import React, { useEffect, useState } from "react";

const ReferralHistory = () => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  const getReferralHistory = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        "http://localhost:5000/referrals/my",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || "Failed to fetch referrals"
        );
      }

      setReferrals(result.data || []);
    } catch (error) {
      console.error("Referral History Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReferralHistory();
  }, []);

  return (
    <div
      style={{
        padding: "30px",
        background: "#f7f7f7",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          padding: "25px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ color: "#f58220" }}>
          Referral History
        </h2>

        {loading ? (
          <p>Loading referrals...</p>
        ) : referrals.length === 0 ? (
          <p>No referrals found.</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "20px",
              }}
            >
              <thead>
                <tr>
                  <th style={thStyle}>Name</th>
                  <th style={thStyle}>Mobile</th>
                  <th style={thStyle}>Company</th>
                  <th style={thStyle}>Category</th>
                  <th style={thStyle}>City</th>
                  <th style={thStyle}>Points</th>
                  <th style={thStyle}>Status</th>
                </tr>
              </thead>

              <tbody>
                {referrals.map((item) => (
                  <tr key={item._id}>
                    <td style={tdStyle}>{item.name}</td>
                    <td style={tdStyle}>{item.mobile}</td>
                    <td style={tdStyle}>{item.company}</td>
                    <td style={tdStyle}>{item.category}</td>
                    <td style={tdStyle}>{item.city}</td>
                    <td style={tdStyle}>{item.points}</td>
                    <td style={tdStyle}>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const thStyle = {
  background: "#17233c",
  color: "#ffffff",
  padding: "12px",
  textAlign: "left",
};

const tdStyle = {
  padding: "12px",
  borderBottom: "1px solid #eee",
};

export default ReferralHistory;